import { connect } from 'react-redux'
import HostedVoice from './HostedVoice'

const stateToProps = () => ({
  isProduction: window.GLOBAL_ENV.API_TYPE === 'production',
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(HostedVoice)



// WEBPACK FOOTER //
// ./src/pages/Services/HostedVoice/HostedVoice.container.js